import React, { useRef, useState } from "react"

import classNames from "gpages/utils/classnames"

import * as styles from "./nav.module.scss"
import logoImg from "@images/logo.png"
import { useScrollEvent } from "@src/utils/hooks/common"
import Clickable from "../clickable"
import Icon from "../icon"
import { useAppContext } from "@src/context/appContext"
import classnames from "gpages/utils/classnames"
import ApplyModal from "../applyModal"

import discordImg from "@images/icons/discord.png"
import xImg from "@images/icons/x-1.png"
import gcoresImg from "@images/icons/gcores.png"
import steamImg from "@images/icons/steam.png"
import config from "@config"

const getItems = (lang, langData) => [
  {
    key: "home",
    title: langData.nav_home,
    to: `/${lang}/`,
  },
  {
    key: "games",
    title: langData.nav_games,
    to: `/${lang}/games/`,
  },
  {
    key: "news",
    title: langData.nav_news,
    to: "https://www.gcores.com/organizations/63175/originals",
  },
  {
    key: "about",
    title: langData.nav_about,
    to: `https://site.gcores.com/publishing_intro/${lang}/`,
  },
  {
    key: "apply",
    title: langData.nav_apply,
    icon: "outlink",
    hideSm: true,
    highlight: true,
  },
]

const Nav = ({ location }) => {
  const [applyModalVisible, setApplyModalVisible] = useState(false)
  const { isAppLayout, langData, lang } = useAppContext()
  const [dropdownVisble, setDropdownVisible] = useState(false)
  const [visible, setVisible] = useState(true)
  const prevScrollTopRef = useRef()
  const currentPathname = location?.pathname?.replace(`/${config.appKey}/`, "/")

  useScrollEvent(() => {
    const scrollTop = window.scrollY
    const prevTop = prevScrollTopRef.current
    if (scrollTop <= 500) {
      setVisible(true)
      return
    }
    if (prevTop >= 0) {
      setVisible(scrollTop < prevTop)
    }
    prevScrollTopRef.current = scrollTop
  })

  return (
    <nav
      id="nav"
      className={classNames(styles.nav, {
        [styles.isDropdown]: dropdownVisble,
        [styles.isHide]: !visible,
      })}
    >
      <Clickable
        className={styles.dropDownMask}
        onClick={() => {
          setDropdownVisible(false)
        }}
      />
      <div>
        <div className={styles.logoContainer}>
          <img src={logoImg} className={styles.logo} alt="logo" />
          <div className={styles.icons}>
            {[
              {
                icon: gcoresImg,
                to: "https://www.gcores.com/users/720120/talks",
              },
              {
                icon: steamImg,
                to: "https://store.steampowered.com/developer/gcores",
              },
              {
                icon: xImg,
                to: "https://x.com/GCORESPUBLISH",
              },
              {
                icon: discordImg,
                to: "https://discord.gg/mEUkzz6qKQ",
              },
            ].map(({ icon, to }, i) => {
              return (
                <a
                  key={to}
                  className={styles.iconLink}
                  href={to}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={icon} alt="icon" />
                </a>
              )
            })}
          </div>
        </div>
        <div className={styles.right}>
          <Clickable
            className={styles.menuBtn}
            onClick={() => {
              setDropdownVisible((prev) => !prev)
            }}
          >
            <Icon icon="burger" />
          </Clickable>
          <div className={styles.menu}>
            <ul>
              {getItems(lang, langData).map(
                ({ title, key, to, icon, highlight, hideSm }, i) => {
                  if (isAppLayout && hideSm) {
                    return null
                  }

                  const isActive = currentPathname === to

                  return (
                    <li
                      key={title || i}
                      className={classnames({
                        [styles.highlight]: highlight,
                        [styles.active]: isActive,
                      })}
                    >
                      <Clickable
                        {...(to?.startsWith("/")
                          ? { to }
                          : {
                              appNavTo: to,
                            })}
                        onClick={() => {
                          if (key === "apply") {
                            setApplyModalVisible(true)
                          }

                          setDropdownVisible(false)
                        }}
                      >
                        {title} <Icon icon={icon} />
                      </Clickable>
                    </li>
                  )
                }
              )}
            </ul>
          </div>
        </div>
      </div>

      <ApplyModal
        isOpen={applyModalVisible}
        onRequestClose={() => {
          setApplyModalVisible(false)
        }}
      />
    </nav>
  )
}

export default Nav
